import { useTranslation } from "react-i18next";
import { Membership } from "../../models/membership";
import moment from "moment";

export function MembershipCell({ membership }: { membership: Membership }) {
  const { t } = useTranslation();

  return (
    <>
      <thead>
        <tr>
          <th>
            {t(`userdetail_m${membership.region.toLowerCase()}_subtitle`)}
          </th>
          <td className={"font-normal text-right"}>
            <span className={"text-wrap"}>
              {t("userdetail_m_updated", {
                "yyyy-mm-dd": membership.updatedAt.format(t("date2_format")),
              })}
            </span>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>{t("userdetail_m_mnumber")}</th>
            <td>{membership.number}
                {membership.endedAt.isBefore(moment.now()) &&
                    <span className={"badge ml-2 badge-sm bg-gray-300 text-gray-500"}>
                        {t("common_userstatus_membershipexpiration")}
                    </span>}
            </td>
        </tr>
        <tr>
            <th>{t("membershipexpiration_date")}</th>
            <td>{membership.endedAt.format(t("date3_format"))}</td>
        </tr>
        <tr>
          <th>{t("userdetail_m_name")}</th>
          <td>
            {t("name_format", {
              first: membership.firstName,
              last: membership.lastName,
            })}
          </td>
        </tr>
      </tbody>
    </>
  );
}
